import * as React from 'react';

import {EmptyStateSmall} from 'shells/empty-states/empty-state-small';
import {Illustration} from 'shells/illustrations/illustration';

import type {ExternalServiceType} from 'nutshell-graphql-types';

import {getServiceNounPlural} from '../helpers';

import type {ExternalServiceTypeFrontend} from './types';

type Props = {
    serviceType: ExternalServiceType | ExternalServiceTypeFrontend;
};

export function EmptyUnloggedInbox(props: Props) {
    const serviceCategoryNounPlural = getServiceNounPlural(props.serviceType);

    return (
        <EmptyStateSmall
            title={`No unlogged ${serviceCategoryNounPlural}`}
            subtitle={`${serviceCategoryNounPlural} that have not been logged as activities will appear here`}
            icon={
                <div style={{width: 80, height: 80}}>
                    <Illustration src='cactus-empty-state' width='100%' height='100%' />
                </div>
            }
        />
    );
}
